import React from "react";
import styled from "styled-components";

const WrapperDiv = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Spinner = styled.div`
  border: 4px solid #dedede;
  border-top: 4px solid #323333;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Loading = () => (
  <WrapperDiv>
    <Spinner />
  </WrapperDiv>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.jsx